import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Subject, takeUntil } from "rxjs";
import { ShipyardService } from "src/app/modules/shipyard/shipyard.service";
import { HeaderService } from "../header/header.service";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { SnackbarComponent } from "../snackbar/snackbar.component";
import { SkuGenerateDialogComponent } from "../sku-generate-dialog/sku-generate-dialog.component";
import { WalmartService } from "src/app/services/walmart.service";

@Component({
  selector: "app-publish-listing-walmart",
  templateUrl: "./publish-listing-walmart.component.html",
  styleUrls: ["./publish-listing-walmart.component.scss"],
})
export class PublishListingWalmartComponent implements OnInit, OnDestroy {
  account:string;
  loader: boolean = false;
  spin: boolean = false;
  publishForm: FormGroup = new FormGroup({
    sku: new FormControl("", [Validators.required]),
    price: new FormControl(0, [Validators.required]),
    qty: new FormControl(1, [Validators.required]),
    condition: new FormControl("New", [Validators.required]),
    visible: new FormControl("", [Validators.required]),
    shippingWeight:new FormControl(0, [Validators.required]),
  });

  itemConditionWalmartArray = [
    "New",
    "New without box",
    "New without tags",
    "Remanufactured",
    "Open Box",
    "Pre-Owned: Like New",
    "Pre-Owned: Good",
    "Pre-Owned: Fair",
    "New with defects",
  ];
  visibleArray = [
    "Animal Accessories",
    "Animal Food",
    "Animal Health & Grooming",
    "Animal Other",
    "Art & Craft",
    "Baby Diapering, Care, & Other",
    "Baby Food",
    "Baby Furniture",
    "Baby Toys",
    "Baby Transport",
    "Beauty, Personal Care, & Hygiene",
    "Bedding",
    "Books & Magazines",
    "Building Supply",
    "Cameras & Lenses",
    "Carriers & Accessories",
    "Cases & Bags",
    "Cell Phones",
    "Ceremonial Clothing & Accessories",
    "Clothing",
    "Computer Components",
    "Computers",
    "Costumes",
    "Cycling",
    "Decorations & Favors",
    "Electrical",
    "Electronics Accessories",
    "Electronics Cables",
    "Electronics Other",
    "Food & Beverage",
    "Footwear",
    "Fuels & Lubricants",
    "Funeral",
    "Furniture",
    "Garden & Patio",
    "Gift Supply & Awards",
    "Grills & Outdoor Cooking",
    "Hardware",
    "Health & Beauty Electronics",
    "Home Decor, Kitchen, & Other",
    "Household Cleaning Products & Supplies",
    "Instrument Accessories",
    "Jewelry",
    "Land Vehicles",
    "Large Appliances",
    "Medical Aids & Equipment",
    "Medicine & Supplements",
    "Movies",
    "Music Cases & Bags",
    "Music",
    "Musical Instruments",
    "Office",
    "Optical",
    "Optics",
    "Other",
    "Photo Accessories",
    "Plumbing & HVAC",
    "Printers, Scanners, & Imaging",
    "Safety & Emergency",
    "Software",
    "Sound & Recording",
    "Sport & Recreation Other",
    "Storage",
    "TV Shows",
    "TVs & Video Displays",
    "Tires",
    "Tools & Hardware Other",
    "Tools",
    "Toys",
    "Vehicle Other",
    "Vehicle Parts & Accessories",
    "Video Games",
    "Video Projectors",
    "Watches",
    "Watercraft",
    "Wheels & Wheel Components",
  ];
  private destroy$ = new Subject<void>();
  gtin: string;
  publisListing: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<PublishListingWalmartComponent>,
    private shipyardService: ShipyardService,
    private headerService: HeaderService,
    private snackBar: MatSnackBar,
    private walmartService: WalmartService,
    private dialog: MatDialog
  ) {
    this.headerService.accountsSelected
      .pipe(takeUntil(this.destroy$))
      .subscribe((e) => {
        this.account = e[0];
      });
  }

  ngOnInit(): void {
    this.publishForm.disable();
  }

  dialogAction(event) {
    if (event === "Create") {
      this.create();
    } else {
      this.close();
    }
  }

  close() {
    this.dialogRef.close();
  }

  create() {
    const payload: any = {
      sku: this.publishForm.value.sku,
      productName: this.publisListing?.title,
      brand: this.publisListing?.brand,
      price: this.publishForm.value.price,
      shippingWeight: this.publishForm.value.shippingWeight,
      multipackQuantity: this.publishForm.value.qty,
      productIdType: 'GTIN',
      productId: this.gtin,
      visible: {
        [this.publishForm.value.visible]: {
          shortDescription: this.publisListing?.description,
          mainImageUrl: this.publisListing?.images[0]?.url
        }
      },
      account: this.account
    };
    this.walmartService
      .CreateWalmartSku(payload)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.spin = false;
          if (res) {
            this.snackBar.openFromComponent(SnackbarComponent, {
              duration: 3000,
              horizontalPosition: "center",
              data: {
                title: "SKU Created Successfully",
                action: "Dismiss",
                type: "success",
              },
            });
            this.dialogRef.close();
          }
        },
        error: (err) => {
          this.spin = false;
          this.snackBar.openFromComponent(SnackbarComponent, {
            duration: 3000,
            horizontalPosition: "center",
            data: {
              title: err?.error?.error[0],
              action: "Dismiss",
              type: "error",
            },
          });
        },
      });
  }

  submit() {
    this.loader = true;
    const payload = {
      account: this.account,
      gtin: this.gtin,
    };
    this.walmartService.GetCatalogByGtin(payload).pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          if(res.items?.length){
            this.publisListing = res?.items[0];
          }
          this.loader = false;
          this.publishForm.enable();
        },
        error: (err) => {
          this.loader = false;
          this.snackBar.openFromComponent(SnackbarComponent, {
            duration: 300000,
            horizontalPosition: "center",
            data: {
              title: err?.error?.error[0],
              action: "Dismiss",
              type: "error",
            },
          });
        },
      });
  }

  search(event) {
    this.gtin = event.target.value;
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  openDialog() {
    this.dialog
      .open(SkuGenerateDialogComponent, {
        width: "400px",
      })
      .afterClosed()
      .subscribe((sku) => {
        if (sku) {
          this.shipyardService
            .checkSkuExist(sku)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: (res) => {
                if (!res) {
                  this.publishForm.get("sku").setValue(sku);
                }
              },
              error: (err) => {
                this.snackBar.openFromComponent(SnackbarComponent, {
                  duration: 3000,
                  horizontalPosition: "center",
                  data: {
                    title: err?.error?.error[0],
                    action: "Dismiss",
                    type: "error",
                  },
                });
              },
            });
        }
      });
  }
}
